<!--Footer Starts-->
<footer [ngClass]="{'centerFooter': cfooter}" *ngIf="copyRightMsg">
  <p class="copyright">{{copyRightMsg}}</p>
</footer>
<!--Footer Ends-->